import { render, staticRenderFns } from "./totalQuantity.vue?vue&type=template&id=58f6ecd5&scoped=true"
import script from "./totalQuantity.vue?vue&type=script&lang=js"
export * from "./totalQuantity.vue?vue&type=script&lang=js"
import style0 from "./totalQuantity.vue?vue&type=style&index=0&id=58f6ecd5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f6ecd5",
  null
  
)

export default component.exports